// CORTE 4-D2 — localización retroactiva de textos guardados:
// si el dueño NUNCA personalizó un campo (== default del template en CUALQUIER idioma),
// se muestra/descarga en su idioma actual. Campos personalizados se respetan tal cual.
import { getTemplateById } from "./stickerTemplates";
import { TEMPLATE_TEXT_I18N } from "./stickerTemplatesI18n";

const defaultsFor = (templateId, field) => {
  const tpl = getTemplateById(templateId);
  if (!tpl) return null;
  const esField = field === "subtitle" ? "subline" : field;
  const set = new Set([tpl[esField] || ""]);
  const tr = TEMPLATE_TEXT_I18N[templateId] || {};
  Object.values(tr).forEach((v) => set.add(v?.[esField] || ""));
  return set;
};

export const localizeSavedTexts = (texts, templateId, lang) => {
  const base = {
    title: texts?.title || "",
    subtitle: texts?.subtitle || "",
    slogan: texts?.slogan || "",
  };
  if (!templateId) return base;
  const tpl = getTemplateById(templateId);
  if (!tpl) return base;
  const target = lang === "es"
    ? { title: tpl.title || "", subtitle: tpl.subline || "", slogan: tpl.slogan || "" }
    : (() => {
        const tr = TEMPLATE_TEXT_I18N[templateId]?.[lang];
        return tr ? { title: tr.title || "", subtitle: tr.subline || "", slogan: tr.slogan || "" } : null;
      })();
  if (!target) return base;
  const out = { ...base };
  for (const field of ["title", "subtitle", "slogan"]) {
    const knowns = defaultsFor(templateId, field);
    if (base[field] && knowns && knowns.has(base[field]) && target[field]) {
      out[field] = target[field];
    }
  }
  return out;
};
